/**
 * This file is used to add or overwrite on the static videojs object properties and methods
 *
 * IMPORTANT: make changes the affected this static object only here, nowhere else (also not in "StaticSkyClickPlayer")
 * The reason is, that we prevent reference error when all the default and our custom properties and methods are on the same inheritance level.
 * Pictorially it mean this:
 *    StaticSkyClickPlayer (This level is only needed, to hide away the default player init function on the static videojs object it self)
 *          -- inherit from --> This (static videojs object)
 */


// *** Imports
import {videojs} from "../components/wrappers/PlayerComponentWrapper";
import SkyClickPlayer from "../components/custom/SkyClickPlayer";
import Constants from "../utils/Constants";
let objectAssign  = require('object-assign');

// *** Variables defined by webpack
// Publish version number from package.json (over webpack plugin, which bring it into js namespace)
declare let VERSION: string;

// *** customized methods and properties for static videojs object
let customizing = {
    VERSION: VERSION, // overwrite videojs version with SkyClick version
    VIDEOJS_VERSION: videojs.VERSION, // backup videojs version
    SKYCLICK_CONSTANTS: Constants, // Provide SkyClick Player constants

    // Official setup method to init SkyClick Player
    setup: SkyClickPlayer.createInstance.bind(SkyClickPlayer)
};

// *** Extend existing static videojs object
declare global {
    interface VideoJSStatic {
        VIDEOJS_VERSION:string
        setup(selector:String|HTMLElement,options?:Object, ready?:() => void):SkyClickPlayer
    }
}

objectAssign(videojs, customizing);



// WEBPACK FOOTER //
// ./src/app/static/StaticVideoJsCustomizing.ts